module.exports = __webpack_public_path__ + "static/media/Screenshotpage4.f16a0c24.png";